import { cn } from "@/lib/cn";

export type LogoVariant = "lockup" | "isotipo" | "wordmark";
export type LogoTone = "white" | "carbon";

export interface LogoProps {
  variant?: LogoVariant;
  tone?: LogoTone;
  className?: string;
  alt?: string;
}

/**
 * Logo de MegaSyR.
 *
 * Los archivos se copian desde `branding/` a `public/brand/` con `make brand`.
 * Nunca se escribe "MegaSyR" con una tipografía parecida: el logotipo usa una
 * fuente que no es la de la interfaz y quedaría mal.
 *
 * Reglas del manual que se respetan aquí:
 *  · El lockup blanco sobre fondos oscuros; el carbón sobre fondos claros.
 *  · Tamaño mínimo 24 px para el isotipo.
 *  · Área de respeto: quien lo use debe dejar libre ~25% de alto alrededor.
 */
export function Logo({
  variant = "lockup",
  tone = "white",
  className,
  alt = "MegaSyR",
}: LogoProps) {
  return (
    <img
      src={`/brand/megasyr-${variant}-${tone}.png`}
      alt={alt}
      draggable={false}
      className={cn("w-auto select-none", className)}
    />
  );
}
